import React from 'react'
import type { RegisterProviderProps } from './Context'
import { RegisterProvider } from './Context'
import { Layout } from './Layout'

export const Register = (props: RegisterProviderProps) => {
  return (
    <RegisterProvider {...props}>
      <Layout />
    </RegisterProvider>
  )
}

export * from './Context'
